import {Component, Input} from '@angular/core';

@Component({
  selector: 'ba-card',
  template: require('./baCard.html'),
})
export class BaCard {
  @Input() title:String;
  @Input() baCardClass:String;
  @Input() cardType:String;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/theme/components/baCard/baCard.component.ts